import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useQuery } from "@tanstack/react-query";
import { odataFetch, ODataServices } from "../../lib/odata-fetch";
import { EquipmentConfigurationProperty } from "../../odata/appu4dm/AppU4DMModel";
import {
  qEquipmentConfigurationProperty,
  QEquipmentConfigurationProperty,
} from "../../odata/equipment/QEquipment";
import { useMachine } from "../machine/use-machine";
import { configurationKeys } from "./configuration-keys";

type Config = "MarkingAutoStart" | "ValidationSkip" | "ValidationAutoComplete";

export function useEquimentConfiguration(
  config: Config,
  service: ODataServices = "Equipment"
) {
  const { machine } = useMachine();
  const { data, ...query } = useQuery({
    queryKey: configurationKeys.getEquiment(config, service),
    queryFn: ({ meta }) =>
      fetchEquimentConfiguration(
        config,
        machine!.EquipmentNId!,
        service,
        meta!.token!
      ),
    enabled: ({ meta }) => !!meta?.token && !!machine?.EquipmentNId,
  });

  return {
    config: data?.value?.[0],
    ...query,
  };
}

async function fetchEquimentConfiguration(
  config: Config,
  machineId: string,
  service: ODataServices = "Equipment",
  token: string
) {
  const builder = createQueryBuilderV4(
    "EquipmentConfigurationProperty",
    new QEquipmentConfigurationProperty()
  ).filter(
    qEquipmentConfigurationProperty.EquipmentConfiguration.getEntity(true)
      .NId.eq(machineId)
      .and(qEquipmentConfigurationProperty.NId.eq(config))
  );

  return odataFetch<EquipmentConfigurationProperty>({
    service,
    builder,
    token,
  });
}
